import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// ── Preload LCP image so browser discovers it before React renders ────────
// (preload implicitly establishes the connection, no separate preconnect needed)
const preloadLCP = document.createElement('link');
preloadLCP.rel = 'preload';
preloadLCP.as = 'image';
preloadLCP.href = 'https://cdn.magicpatterns.com/uploads/uSmcroKTKZCXej782ZGJuq/ChatGPT_Image_23_feb_2026,_17_24_01_(1).png';
preloadLCP.setAttribute('fetchpriority', 'high');
document.head.appendChild(preloadLCP);
// ── Render app first, then load non-critical scripts ──────────────────────
render(<App data-id="element-58" />, document.getElementById('root'));
// ── Defer Meta Pixel to after initial render (saves ~340ms from critical path)
function loadMetaPixel() {
  !function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s);
    } else {
      b.head.appendChild(t);
    }
  }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  (window as any).fbq('init', '1927478928649366');
  (window as any).fbq('track', 'PageView');
}
// Load pixel after page is interactive (requestIdleCallback or fallback to setTimeout)
if ('requestIdleCallback' in window) {
  ;
  (window as any).requestIdleCallback(loadMetaPixel);
} else {
  setTimeout(loadMetaPixel, 1500);
}